import React from 'react'
import App from './App'
import UserProvider from './providers/UserProvider'

import './App.css'

function Container() {
  return (
    <UserProvider>
      <App />
    </UserProvider>
  )
}

export default Container
